import React from 'react';
import { Pressable, Text, TouchableOpacity, View } from 'react-native';

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Icon, IconName } from '../components/Icon';
import { Image } from 'expo-image';
import tw from '../styles/tailwind';
import { createChildrenNavigator, createMyAdminNavigator } from './AdminWebNavigators';
import { StackActions } from '@react-navigation/native';

import { Platform } from 'react-native';
import { useState } from 'react';
import { useSelector } from 'react-redux';


import PaymentRequestScreen from '@/screens/Vinte/PaymentRequests/PaymentRequestsScreen';
import PaymentRequestDetailScreen from '@/screens/Vinte/PaymentRequests/PaymentRequestDetailScreen';
import CommunitiesScreen from '@/screens/Vinte/Communities/CommunitiesScreen';
import ProvidersScreen from '@/screens/Vinte/Providers/ProvidersScreen';
import ProviderDetailScreen from '@/screens/Vinte/Providers/ProviderDetailScreen';
import VinteReportsScreen from '@/screens/Vinte/Reports/VinteReportsScreen';
import ReportDetailScreen from '@/screens/Vinte/Reports/ReportDetailScreen';



//!
// https://ui.shadcn.com/docs/components/sidebar



const ScreenFactory = (screenName, navigateTo = "") => ({ route, navigation }) => {
  console.log(`%c ${screenName}`, 'color: purple', route)


  //! BORRAR
  // Esto de abajo es el mismo state de AdminWebNavigator.state
  // const state = useNavigationState((state) => state);
  // console.log(state)


  return (<View>
    <Text
      onPress={() => {
        navigation.navigate(navigateTo, {
          // feeId: fee.uuid,
          communityId: route.params?.communityId,
        })
      }}
    >Soy {screenName} {navigateTo ? `Y navego a [${navigateTo}]` : ''}</Text>
    <Text>{route.key}</Text>
  </View>)
}



function VinteNavBar({ state, descriptors, navigation }) {
  // fix puerco
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { communities } = useSelector(state => state.status)


  const onPress = (route, index) => {
    // Mismo patrón que AdminSidebar: navigate (no reset) al tab YA montado.
    // El reset recreaba VinteTabStack sin estado anidado -> routes[0].state quedaba
    // undefined y AdminLayout no podía leer la ruta enfocada (fullscreen no aplicaba).
    const detailCount = state.routes.length - 1;
    if (detailCount > 0) {
      navigation.dispatch(StackActions.pop(detailCount));
    }

    navigation.navigate("VinteTabStack", { screen: route });

    setSelectedIndex(index)
  }

  const renderTab = (index: number, name: string, route: string, icon: IconName) => {
    // const isFocused = state.index === index;
    const isFocused = selectedIndex === index;

    return (
      <TouchableOpacity
        style={tw`items-center w-18`}
        accessibilityRole="button"
        accessibilityState={isFocused ? { selected: true } : {}}
        // accessibilityLabel={options.tabBarAccessibilityLabel}
        // testID={options.tabBarTestID}
        onPress={() => onPress(route, index)}
      // onLongPress={onLongPress}
      >
        <Icon
          name={icon}
          variant={isFocused ? 'filled' : 'default'}
          size={21.2}
          style={tw`-mb-1`}
        />

        <Text style={tw.style(`text-gray-400 text-xs mt-2`, isFocused && `text-secondary font-600`)}>{name}</Text>
      </TouchableOpacity>
    )
  }
  return (
    <View style={tw`h-16 row bg-secondary shadow-2xl`}>
      {/* Logo DD */}
      <View style={tw`h-100% w-18 bg-white px-15 justify-center items-center mr-10`}>
        {/* <Icon name='qr-dd' color={tw.color('secondary')} size={36} /> */}
        <Image source={require('../assets/images/svgs/vinte_logo.png')} style={tw`w-24 h-12`} contentFit="contain" />
      </View>


      {/* Tabs */}
      <View style={tw`row gap-x-3 bg-white rounded-2xl px-3 py-2`}>
        {renderTab(0, 'Pendientes',  "Vinte.PaymentRequests.Pending", 'navResumen')}
        {renderTab(1, 'Solicitudes', "Vinte.PaymentRequests",         'navFinanzas')}
        {renderTab(2, 'Desarrollos', "Vinte.Communities",             'navViviendas')}
        {renderTab(3, 'Proveedores', "Vinte.Providers",               'navPerfil')}
        {renderTab(4, 'Reportes',    "Vinte.Reports",                 'navIncidencias')}
      </View>
    </View>
  )
}



const DeepStackScreens = [
  // { name: "Admin.Home", component: AdminDashboardScreen, options: { title: "Resumen" } },
  { name: "Vinte.PaymentRequests.Pending", component: PaymentRequestScreen, initialParams: { filterPending: true } },
  { name: "Vinte.PaymentRequests", component: PaymentRequestScreen },
  { name: "Vinte.Communities", component: CommunitiesScreen, options: { title: "Desarrollos", layout: 'fullscreen' as const } },
  { name: "Vinte.Providers", component: ProvidersScreen, options: { title: "Proveedores" } },
  { name: "Vinte.Reports", component: VinteReportsScreen, options: { title: "Reportes", layout: 'fullscreen' as const } },

  { name: "Test.Home", component: ScreenFactory("DeepStackScreen2", "Test.Detail2") },
  // { name: "Admin.Units.Index", component: AdminUnitsScreen, options: { title: "Viviendas" } },
  // { name: "Admin.Fees.Index", component: AdminFeesScreen, options: { title: "Finanzas" } },
  // { name: "Admin.AccessControl.Index", component: AccessControlScreen, options: { title: "Accesos" } },
  // { name: "Admin.Settings.Index", component: AdminSettingsScreen, options: { title: "Configuración" } },
]

// Mapa derivado de DeepStackScreens para que AdminLayout sepa qué layout aplicar.
// Pasado al outer navigator via las options del screen "VinteTabStack".
const innerLayouts: Record<string, 'fullscreen' | 'master-detail'> = Object.fromEntries(
  DeepStackScreens
    .filter((s: any) => s.options?.layout)
    .map((s: any) => [s.name, s.options.layout])
);

const MainStackScreens = [
  { name: "VinteTabStack", component: DeepStackNavigator, options: { title: "Dashboard", innerLayouts } },

  // { name: "Test.Detail", component: ScreenFactory("MainStack - Detail1Screen", "Test.Detail2"), options: { title: "Calonsho" } },
  // { name: "Test.Detail2", component: ScreenFactory("MainStack - Detail2Screen", "Test.Detail3"), options: { title: "Calonsho" } },
  // { name: "Test.Detail3", component: ScreenFactory("MainStack - Detail3Screen", "Test.Detail3"), options: { title: "Calonsho" } },


  // { name: "Vinte.PaymentRequests.Detail", component: ScreenFactory("Vinte.PaymentRequests.Detail"), options: { title: "Detalle de Vivienda" } },
  { name: "Vinte.PaymentRequests.Detail", component: PaymentRequestDetailScreen, options: { title: "Solicitud de Pago" } },
  { name: "Vinte.Providers.Detail", component: ProviderDetailScreen, options: { title: "Detalle del proveedor" } },
  { name: "Vinte.Reports.Detail", component: ReportDetailScreen, options: { title: "Reporte" } },
]



const VinteWebNavigator = createMyAdminNavigator()


export default function MasterNavigatorStack({ ...props }) {
  const insets = useSafeAreaInsets();

  // este no tiene mucho caso, props.route siempre es name : "Admin.Dashboard"
  // nota 2: creo ya no, aparte ahora ya se llama "AdminStack"
  console.log("VinteWebNavigator props", props?.route?.params?.params)


  return (
    <VinteWebNavigator.Navigator
      // initialRouteName="Admin.Home"
      screenOptions={{
        headerShown: false,
        topBar: props => <VinteNavBar {...props} />
      }}>

      {MainStackScreens.map(screen =>
        <VinteWebNavigator.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={screen.options}
          initialParams={props?.route?.params?.params}
        />
      )}

    </VinteWebNavigator.Navigator>
  )
}





//  Para debug
// const ChildrenWebNavigator = createBottomTabNavigator();
const ChildrenWebNavigator = createChildrenNavigator()

function DeepStackNavigator({ route }) {
  return (
    <ChildrenWebNavigator.Navigator
      initialRouteName={DeepStackScreens[0].name}
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: 'red',
        }
      }}
    >
      {DeepStackScreens.map(screen =>
        <ChildrenWebNavigator.Screen
          key={screen.name}
          name={screen.name}
          component={screen.component}
          options={{
          }}
          initialParams={{ ...route.params, ...screen.initialParams || {}}}
        />
      )}
    </ChildrenWebNavigator.Navigator>
  )
}

